import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAdmin } from '../context/AdminContext';
import { toast } from 'sonner';
import { Shield, Loader2 } from 'lucide-react';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { adminLogin } = useAdmin();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username || !password) {
            toast.error('Please fill in all fields');
            return;
        }
        
        setLoading(true);
        try {
            await adminLogin(username, password);
            toast.success('Welcome, Admin!');
            navigate('/admin/dashboard');
        } catch (error) {
            toast.error(error.response?.data?.detail || 'Invalid credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-foreground flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="w-16 h-16 rounded-2xl bg-primary mx-auto flex items-center justify-center mb-4">
                        <Shield className="w-8 h-8 text-primary-foreground" />
                    </div>
                    <h1 className="font-heading font-bold text-3xl text-background tracking-tight">
                        Admin Portal
                    </h1>
                    <p className="text-background/60 mt-2">
                        Sign in to manage your application
                    </p>
                </div>

                <div className="bg-card rounded-2xl p-8 shadow-xl">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="space-y-2">
                            <Label htmlFor="username">Username</Label>
                            <Input
                                id="username"
                                type="text"
                                placeholder="admin"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="h-12"
                                data-testid="admin-username-input"
                            />
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="password">Password</Label>
                            <Input
                                id="password"
                                type="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="h-12"
                                data-testid="admin-password-input"
                            />
                        </div>

                        <Button 
                            type="submit" 
                            className="w-full h-12 rounded-full text-base"
                            disabled={loading}
                            data-testid="admin-login-btn"
                        >
                            {loading ? (
                                <>
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                    Signing in...
                                </>
                            ) : (
                                'Sign in to Admin'
                            )}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
